import React from 'react'
import styles from '../Extended/Extended.module.css'
const Extended = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.ExtendedImg}>
                    <img src='Images/extended-img.webp' alt='middle aged presbyopic woman looking into camera' loading="lazy" decoding="async" />
                </div>
                <div className={styles.RightSection}>
                    <div className={styles.content}>
                        <div className={styles.DeseyneLogo}>
                            <img src='Images/Deseyne Logo.webp' alt='Deseyne® product logo' loading="lazy" decoding="async" />
                        </div>
                        <h2 className={styles.title}>Deseyne <span className={styles.sppanText}>(</span>vifilcon C<span className={styles.sppanText}>)</span> Daily Disposable Soft <span className={styles.sppanText}>(</span>hydrophilic<span className={styles.sppanText}>)</span> Contact Lens for Presbyopia with Extended Depth of Focus <span className={styles.sppanText}>(</span>EDOF<span className={styles.sppanText}>)</span></h2>
                        <h3 className={styles.subtitle}>Supports continuous focus from near to far, without cognitive adaptation. </h3>
                        <div className={styles.description}>
                            <p>The Deseyne® contact lens is the first and only FDA-cleared daily disposable featuring an Extended Depth of Focus (EDOF) optical design for presbyopia</p>
                            <p>Breakthrough contact lens technology introduces a new approach to presbyopic correction. At its core is a small, on-axis, hyper-refrective zone that prevents axial and paraxial light from contributing to retinal image formation.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Extended
